export const CLINICAL_LOCATIONS = 'clinicalLocations';
export const MEDICAL_SERVICES = 'medicalServices';
export const CLINICAL_LOCATION_MEDICAL_SERVICE = 'clinicalLocationMedicalService';
export const GROUPS = 'groups';
